export type RoundingFunction = (value: number) => number;
export enum Joule {
  UNIT = 'KJ',
  CONVERSION = 4.184,
}
